import {
  //
  ADD_CARE_HOME_GROUP,
  ADD_CARE_HOME_GROUP_FAILURE,
  ADD_CARE_HOME_GROUP_SUCCESS,
  //
  DELETE_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP_FAILURE,
  DELETE_CARE_HOME_GROUP_SUCCESS,
  //
  EDIT_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP_FAILURE,
  EDIT_CARE_HOME_GROUP_SUCCESS,
  //
  FETCH_CARE_HOME_GROUPS,
  FETCH_CARE_HOME_GROUPS_FAILURE,
  FETCH_CARE_HOME_GROUPS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_CARE_HOME_GROUP,
  SEARCH_CARE_HOME_GROUP_SUCCESS,
  SEARCH_CARE_HOME_GROUP_FAILURE,
  //
  GENERATE_COMPANY_CODE,
  GENERATE_COMPANY_CODE_SUCCESS,
  GENERATE_COMPANY_CODE_FAILURE,
  //
  GENERATE_COMPANY_ADDRESS,
  GENERATE_COMPANY_ADDRESS_SUCCESS,
  GENERATE_COMPANY_ADDRESS_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  INVITE_COMPANY,
  INVITE_COMPANY_SUCCESS,
  INVITE_COMPANY_FAILURE,
  //
  TOGGLE_DIRECT_CLAIM_MODAL,
  DIRECT_CLAIM_COMPANY,
  DIRECT_CLAIM_COMPANY_SUCCESS,
  DIRECT_CLAIM_COMPANY_FAILURE,
} from "./constants";

// List
export const fetchCareHomeGroups = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS,
  payload,
});
export const fetchCareHomeGroupsSuccess = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS_SUCCESS,
  payload,
});
export const fetchCareHomeGroupsFailure = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addCareHomeGroup = (payload) => ({
  type: ADD_CARE_HOME_GROUP,
  payload,
});
export const addCareHomeGroupSuccess = (payload) => ({
  type: ADD_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const addCareHomeGroupFailure = (payload) => ({
  type: ADD_CARE_HOME_GROUP_FAILURE,
  payload,
});
// EDIT
export const editCareHomeGroup = (payload) => ({
  type: EDIT_CARE_HOME_GROUP,
  payload,
});
export const editCareHomeGroupSuccess = (payload) => ({
  type: EDIT_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const editCareHomeGroupFailure = (payload) => ({
  type: EDIT_CARE_HOME_GROUP_FAILURE,
  payload,
});
// DELETE
export const deleteCareHomeGroup = (payload) => ({
  type: DELETE_CARE_HOME_GROUP,
  payload,
});
export const deleteCareHomeGroupSuccess = (payload) => ({
  type: DELETE_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const deleteCareHomeGroupFailure = (payload) => ({
  type: DELETE_CARE_HOME_GROUP_FAILURE,
  payload,
});
// SEARCH
export const searchCareHome = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP,
  payload,
});
export const searchCareHomeSuccess = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const searchCareHomeFailure = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP_FAILURE,
  payload,
});
// GENERATE COMPANY CODE
export const generateCompanyCode = (payload, onSuccess) => ({
  type: GENERATE_COMPANY_CODE,
  payload,
  onSuccess,
});
export const generateCompanyCodeSuccess = (payload) => ({
  type: GENERATE_COMPANY_CODE_SUCCESS,
  payload,
});
export const generateCompanyCodeFailure = (payload) => ({
  type: GENERATE_COMPANY_CODE_FAILURE,
  payload,
});
// GENERATE COMPANY ADDRESS
export const generateCompanyAddress = (payload, onSuccess) => ({
  type: GENERATE_COMPANY_ADDRESS,
  payload,
  onSuccess,
});
export const generateCompanyAddressSuccess = (payload) => ({
  type: GENERATE_COMPANY_ADDRESS_SUCCESS,
  payload,
});
export const generateCompanyAddressFailure = (payload) => ({
  type: GENERATE_COMPANY_ADDRESS_FAILURE,
  payload,
});
// INVITE COMPANY ADMINISTRATOR
export const toggleInviteModal = (payload) => ({
  type: TOGGLE_INVITE_MODAL,
  payload,
});
export const inviteCompany = (payload, onSuccess) => ({
  type: INVITE_COMPANY,
  payload,
  onSuccess,
});
export const inviteCompanySuccess = (payload) => ({
  type: INVITE_COMPANY_SUCCESS,
  payload,
});
export const inviteCompanyFailure = (payload) => ({
  type: INVITE_COMPANY_FAILURE,
  payload,
});

// DIRECT COMPANY CLAIM
export const toggleDirectClaimModal = (payload) => ({
  type: TOGGLE_DIRECT_CLAIM_MODAL,
  payload,
});
export const directClaimCompany = (payload, onSuccess) => ({
  type: DIRECT_CLAIM_COMPANY,
  payload,
  onSuccess,
});
export const directClaimCompanySuccess = (payload) => ({
  type: DIRECT_CLAIM_COMPANY_SUCCESS,
  payload,
});
export const directClaimCompanyFailure = (payload) => ({
  type: DIRECT_CLAIM_COMPANY_FAILURE,
  payload,
});
